import React, { PureComponent, useEffect } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { styles } from '../../containers/dockPadStyle'
import { compose } from 'redux'
import DialogTitle from '@material-ui/core/DialogTitle'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import templates from '../../containers/formTemplate'
import Button from '@material-ui/core/Button'
import t from 'tcomb-form'
import { entityActions } from '../../actions/entity.actions'
import { alertActions } from '../../actions/alert.actions'
import Typography from '@material-ui/core/Typography'
import Geocoder from '../GeocoderInput'
import TextField from '@material-ui/core/TextField';
import { connect } from 'react-redux'
import { getProjectName, getProjectLatitude, getProjectLongitude, getProjectAddress, getProjectId, getReportDays } from '../../selectors/project.selector'
import { isProjectDialogOpenSelector } from '../../selectors/dialog.selector'
import { withRouter } from 'react-router-dom'
import { ThunkDispatch } from 'redux-thunk'
import { dialogActions } from '../../actions/dialog.actions';
import WeekdayPicker from '../WeekdayPicker';
import { Divider } from '@material-ui/core'
import { phasePlanActions } from '../../actions/phaseplan.actions'
import { getSelectedLookaheadId } from '../../selectors/lookahead.selector'
import { firebaseConnect } from 'react-redux-firebase'

t.form.Form.templates = templates


const queryParams = {
  country: 'us'
}

const mapAccess = {
  mapboxApiAccessToken: "pk.eyJ1IjoicmFkemVsbCIsImEiOiJjanU3OWVicGEwM2k3NDluemN4emY3MDlzIn0.0XOKVhnsvNFQ8_oXhv4jKg"
}

interface Props {

  history: History;
  openMRPDialog: () => void,
  onWeekInit: (indexes: number[]) => void,
  reportDays: number[]

}

type State = {
}

class _AddProjectContent extends PureComponent<Props, State> {

  componentDidMount() {
    const { onWeekInit  } = this.props
    const { dispatch, editProjectId, history,openMRPDialog } = this.props;

    const reportDays = !!editProjectId ? this.props.reportDays : [0,1,2,3,4]

    onWeekInit(reportDays)

  }

  constructor(props) {
    super(props)

    let selectedLocation = null
    let locationValue = null;

    const { editProjectId, projectAddress, latitude, longitude, projectName } = props
    if (
      !!editProjectId &&
      !!longitude &&
      !!latitude &&
      !!projectAddress
    ) {
      selectedLocation = {
        addressName: projectAddress,
        longitude: longitude,
        latitude: latitude
      };

      locationValue= selectedLocation.addressName;
    }

    const name = !!editProjectId ? projectName : null


    
    this.state = {
      viewport: {},
      name: name,
      
      selectedLocation: selectedLocation,
      locationValue: locationValue
    };
  }

  handleCancel = () => {
    const { dispatch } = this.props;
    dispatch(entityActions.closeProjectDialog());
  };

  handleSubmit() {
      const { dispatch, editProjectId, history,openMRPDialog } = this.props;

      const { selectedLocation, name } = this.state;

      if (
        !!name &&
        !!selectedLocation &&
        !!selectedLocation.addressName &&
        !!selectedLocation.longitude &&
        !!selectedLocation.latitude
      ) {
        dispatch(
          entityActions.createProject(
            editProjectId,
            name,
            selectedLocation.addressName,
            selectedLocation.longitude,
            selectedLocation.latitude
          )
        );

        if(!editProjectId) {
          openMRPDialog()
        }

        //history.push('/')
      } else if(!!name && !selectedLocation) {
        dispatch(
          entityActions.createProject(
            editProjectId,
            name,
          )
        )
        
        if(!editProjectId) {
          //openMRPDialog()
        } else {
          
        }

        //history.push('/')

      } else {
       dispatch(alertActions.error("Invalid Form"));
     }

     this.handleCancel()

  }

  onGeocoderSelect = (viewport, item) => {
    this.setState({
      viewport,
      locationValue: item.place_name,
      selectedLocation: {
        addressName: item.place_name,
        longitude: viewport.longitude,
        latitude: viewport.latitude
      }
    });
  };

  onAddressChange = value => {
    this.setState({ locationValue: value });
  };

  handleNameChange = event => {
    this.setState({ name: event.target.value });
  }

  render() {
    const { viewport, locationValue } = this.state;

    return (
      <div>
        <TextField
          fullWidth
          label="Name"
          variant="filled"

          margin="normal"
          value={this.state.name}
          onChange={this.handleNameChange}
        />

        <Geocoder
          onChange={this.onAddressChange}
          value={locationValue}
          style={{ width: "100%" }}
          {...mapAccess}
          viewport={viewport}
          onSelected={this.onGeocoderSelect}
          hideOnSelect={true}
          queryParams={queryParams}
        />

        <Typography style={{marginTop: 16}} variant='body2' >
          Daily Report Days
        </Typography>
        <WeekdayPicker />

        <DialogActions>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexBasis: "auto",
              width: "100%"
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <Button
                style={{ marginRight: "8px" }}
                onClick={this.handleCancel.bind(this)}
                variant="outlined"
              >
                Cancel
              </Button>
              <Button
                style={{ marginLeft: "8px" }}
                onClick={this.handleSubmit.bind(this)}
                variant="outlined"
                color="primary"
              >
                Create
              </Button>
            </div>
          </div>
        </DialogActions>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {

  return {
      openMRPDialog: () => dispatch(dialogActions.openMRPDialog()),
      onWeekDayClicked: (index:number) => dispatch(phasePlanActions.lookaheadOffDaySelected(index)),
      onWeekInit: (indexes:number[]) => dispatch(phasePlanActions.lookaheadOffDayBulkSelected(indexes))

      

  }
};
const AddProjectContent = compose(
  withRouter,
  connect((state, props) => {
    return {
      projectName: getProjectName(state),
      editProjectId: state.homeView.editProjectId,
      latitude: getProjectLatitude(state),
      longitude: getProjectLongitude(state),
      projectAddress: getProjectAddress(state),
      reportDays: getReportDays(state)
    }
  }),
  connect(null, mapDispatchToProps)
)(_AddProjectContent)

class AddProjectDialog extends PureComponent {

  state = {
    viewport: {},
    isEntered: false
  }

  onEnter = () => {
    this.setState({
      isEntered: true
    })
  }
  
  onExit = () => {
    this.setState({
      isEntered: false
    })
  }

  render() {
    const {
      isProjectDialogOpen,
      classes
    } = this.props;

    return (
      <Dialog
        onEnter={this.onEnter}
        onExit={this.onExit}
        open={isProjectDialogOpen}
        maxWidth='sm'
        fullWidth
        aria-labelledby='simple-dialog-title' >
          <div className={classes.ProjectTitleContainer}>
            <Typography variant='h1' className={classes.ProjectTitle}>Hello! Let’s start to work.</Typography>
            <Typography className={classes.ProjectSubtitle}>Create your first project now</Typography>
          </div>

          <div className={classes.ProjectContentContainer}>
            <AddProjectContent isEntered={this.state.isEntered} />
          </div>
      </Dialog>
    )
  }
}

const mapStateToProps = (state: any) => {
  return {
    isProjectDialogOpen: isProjectDialogOpenSelector(state),

  }
};




export default compose(
  withStyles(styles, { withTheme: true }),

  connect(mapStateToProps, mapDispatchToProps)

)(
  AddProjectDialog
)



// WEBPACK FOOTER //
// ./src/components/Dialogs/AddProjectDialog.tsx